<template>
  <div>
    <exposure-drilldown
      read-url="/api/report/FuturePastDistributedHedge/drilldown"
      export-url="/api/report/FuturePastDistributedHedge/exportDrillDown"
      :reportParameters="lastParams"
      :value="drilldownOpen"
      @input="drilldownOpen = $event"
    />
    <page-toolbar>
      <exposure-toolbar
        :showClient="this.clientId == 0"
        :showSummaryView="true"
        :marketId="this.marketId"
        @change="onChange"
        @export="onExport"
        @openChart="showChart"
      />
    </page-toolbar>
    <div ref="container" class="grid"></div>
    <simple-dialog v-model="chartDialog" :isDialog="false" :width="432" :height="432" title="">
      <div class="chart" ref="distributionChart" />
      <v-progress-linear :indeterminate="true" v-if="chartLoading"></v-progress-linear>
    </simple-dialog>
  </div>
</template>

<script>
import PageToolbar from '@/components/PageToolbar'
import ExposureToolbar from '../../components/Report/FuturePastDistributeHedgeToolbar'
import report from '../../dashboard-components/product-hedge-distribution'
import reportChart from '../../dashboard-components/product-hedge-distribution_chart'
import SimpleDialog from '@/components/SimpleDialog'
import params from '../../helpers/params'
import ExposureDrilldown from '@/components/Report/ExposureDrilldown'
import {mapGetters} from 'vuex'
import {getDataItem} from '@/helpers/kendo-helpers'

export default {
  mounted() {
    this.$el.addEventListener('click', this.drilldownClick, false)
  },
  data() {
    return {chartDialog: false, chartLoading: false, lastParams: null, drilldownOpen: false}
  },
  methods: {
    drilldownClick({target}) {
      const isGroupHeader = /group-header/.test(target.className)
      const isChildDrillDown = /DrillDown/.test(target.className)
      if (!(isGroupHeader || isChildDrillDown)) return
      let {KeyName, Month} = getDataItem(target)

      if (isGroupHeader) {
        Month = ''
      }
      const drilldownParams = {KeyName, Month}

      this.lastParams = {...this.lastParams, ...drilldownParams}
      this.drilldownOpen = true
    },
    onChange(options) {
      this.lastParams = options
      report.render(kendo.jQuery(this.$refs.container), options, 'report')
    },
    async showChart(params) {
      kendo.destroy(this.$refs.distributionChart)
      kendo.jQuery(this.$refs.distributionChart).empty()
      this.chartDialog = true
      this.chartLoading = true
      await reportChart.render(this.$refs.distributionChart, params).catch(() => {
        this.chartLoading = false
      })
      this.chartLoading = false
    },
    onExport(e) {
      const qs = params.fromObject({
        t: this.tokenString,
        ...e,
      })
      location.href = `/api/report/FuturePastDistributedHedge/Export?${qs}`
    },
  },
  beforeDestroy() {
    kendo.destroy(this.$refs.container)
    this.$el.removeEventListener('click', this.drilldownClick)
  },
  components: {
    PageToolbar,
    ExposureToolbar,
    SimpleDialog,
    ExposureDrilldown,
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    ...mapGetters({marketId: 'app/marketId'}),
  },
}
</script>
<style>
div.group-header {
  text-align: right;
}
.totalDrillDown {
  text-decoration: underline;
  cursor: pointer;
}
</style>
